import { Stack, Typography } from '@mui/material';
import { Area, Unit } from '@silbo/core';
import { useTranslation } from 'react-i18next';
import { describeBedLocation } from '../utils/bed-location';

type BedLocationProps = {
  bed: Area;
  unit?: Unit;
};

/** Le lit, sa chambre et son unité. Jamais le patient. */
const BedLocation = ({ bed, unit }: BedLocationProps) => {
  const { t } = useTranslation('environmental-cleaning');

  return (
    <Stack>
      <Typography fontWeight={600}>{bed.name}</Typography>
      <Typography variant="body2" color="secondary">
        {describeBedLocation(t, bed, unit)}
      </Typography>
    </Stack>
  );
};

export default BedLocation;
